import {
  GetUnauthenticatedAppointmentSlotsRequest,
  GetUnauthenticatedAppointmentSlotsResponse,
} from '.';
import { EnvironmentExtended } from '../../../environment/index';
import Service from '../../framework/service';
import { GetUnauthenticatedAppointmentSlotsServiceName } from '../../framework/serviceConfig';

class GetUnauthenticatedAppointmentSlotsService extends Service<
  GetUnauthenticatedAppointmentSlotsRequest,
  GetUnauthenticatedAppointmentSlotsResponse
> {
  constructor() {
    super(
      EnvironmentExtended.getAppointmentServiceName(),
      GetUnauthenticatedAppointmentSlotsServiceName
    );
  }

  public async execute(
    request: GetUnauthenticatedAppointmentSlotsRequest
  ): Promise<GetUnauthenticatedAppointmentSlotsResponse> {
    return await this.post(request);
  }

  protected handleSuccess(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data: any
  ): GetUnauthenticatedAppointmentSlotsResponse {
    return data;
  }
  protected handleError(
    message: string
  ): GetUnauthenticatedAppointmentSlotsResponse {
    return { succeeded: false, error: message };
  }
}

export const GetUnauthenticatedAppointmentSlotsApiService =
  new GetUnauthenticatedAppointmentSlotsService();
